/**
 * Combine classNames
 * @see {@link https://dev.to/gugaguichard/replace-clsx-classnames-or-classcat-with-your-own-little-helper-3bf|Replace clsx, classnames or classcat with your own little helper}
 */
export default function cx(...args) {
  return args
    .flat()
    .filter((x) => x != null && typeof x !== 'boolean')
    .join(' ')
}
